module.exports = __webpack_public_path__ + "eed031e5f.jpg";